import $api from "../http";
import { IInvoiceForTable } from "../models/Invoice";

class InvoiceServiceClass {
  getInvoices(
    currentPage: number | undefined,
    pageSize: number | undefined,
    queryOptions?: { from: string | null; to: string | null; userId: string | null }
  ) {
    let queryString = `currentPage=${currentPage}&pageSize=${pageSize}`;
    if (queryOptions) {
      if (queryOptions.from) {
        queryString += `&fromDate=${queryOptions.from}`;
      }
      if (queryOptions.to) {
        queryString += `&toDate=${queryOptions.to}`;
      }
      if (queryOptions.userId) {
        queryString += `&userId=${queryOptions.userId}`;
      }
    }
    return $api.get<{ data: IInvoiceForTable[]; totalCount: number }>(`api/invoice?${queryString}`);
  }
}

export const InvoiceService = new InvoiceServiceClass();
